/*
* Price range utilises a price slider to consolidate minimum and maximum price values on a search.
* Requires jQuery UI Slider.
*/

Price_range = {
	p_slider_id : '#property-list-search .price-range-slider'
	,
	set_slider : function(price_min = 0, price_max = 0, price_min_current = 0, price_max_current = 0, price_step = 1)
	{
		// Find the slider.
		var price_range_slider = jQuery(Price_range.p_slider_id);
		
		// Get default price parameters from data attributes.
		var price_min = parseInt( price_range_slider.attr('data-sh-price-min') );
		var price_max = parseInt( price_range_slider.attr('data-sh-price-max') );
		var price_min_current = parseInt( price_range_slider.attr('data-sh-price-min-current') );
		var price_max_current = parseInt( price_range_slider.attr('data-sh-price-max-current') );
		var price_step = parseInt( price_range_slider.attr('data-sh-price-step') );
		
		// TODO: Look for over-rides in the parameters.
		
		// Start range values on currently set values. Default to absolute positions if not found.
		var start_min = ( isNaN(price_min_current) ) ? price_min : price_min_current;
		var start_min_label = numeral(start_min).format('0,0');
		var start_max = ( isNaN(price_max_current) ) ? price_max : price_max_current;
		var start_max_label = numeral(start_max).format('0,0');
		
		// Get tracking elements. These track values from page load to page load.
		tracking_min = price_range_slider.find('input[name="price_min"]');
		tracking_max = price_range_slider.find('input[name="price_max"]');
		
		// Set tracking elements start values.
		//tracking_min.val(start_min);
		//tracking_max.val(start_max);
		
		// Feedback elements reflect the price range on screen.
		var feedback_min = price_range_slider.find('.price-min-feedback');
		var feedback_max = price_range_slider.find('.price-max-feedback');
		
		// Set feedback elements on start.
		feedback_min.find('.value').html(start_min_label);
		feedback_max.find('.value').html(start_max_label);
		
		price_range_slider.find('.slider').slider({
			range: true,
			min: price_min,
			max: price_max,
			values: [ start_min, start_max ],
			step: price_step,
			slide: function( event, ui ){
					
				// Get values from slider.
				var min = ui.values[0];
				var max = ui.values[1];
				
				// Update tracking elements.
				tracking_min.val(min);
				tracking_max.val(max);
				
				// Update feedback elements with new slider info.
				var options = {};
				options.min = min;
				options.max = max;
				
				// Setup custom events.
				feedback_min.trigger('sh_property_search_price_update',options);
				feedback_max.trigger('sh_property_search_price_update',options);
			}
		});
		
		// Setup minimum feedback element to respond to updated slider.
		feedback_min.on('sh_property_search_price_update',function(event,pm_options){
			var min_label = numeral(pm_options.min).format('0,0');
			feedback_min.find('.value').html(min_label);
		});
		
		// Setup maximum feedback element to respond to updated slider.
		feedback_max.on('sh_property_search_price_update',function(event,pm_options){
			var max_label = numeral(pm_options.max).format('0,0');
			feedback_max.find('.value').html(max_label);
		});
	}
	,
	live_mode : function()
	{
		// Find the slider.
		var price_range_slider = jQuery(Price_range.p_slider_id);
		
		// Update settings.
		var config = {};
		config.price_min = 0;
		config.price_min_current = 0;
		config.price_max = 50000;
		config.price_max_current = 50000;
		Price_range.update_settings(config);
		
		// Update label.
		price_range_slider.find('.feedback h4').text('Based on live price totals');
	}
	,
	init : function()
	{
		// Show price range modules.
		jQuery('.price-range').removeClass('oc-hide');
		
	    // Setup slider.
	    Price_range.set_slider();
	    
		// Respond to Arrival and Departure DatePicker events.
	    jQuery(document).on('oc__property_search_arrival_select oc__property_search_departure_select',function(event,pm_options){
			
			// Convert PriceRange to Live Pricing Mode.
			Price_range.live_mode();
			
			///jQuery('input[name="price_min"]').val('0');
			///jQuery('input[name="price_max"]').val('50000');
			
			// Find the slider.
			///var price_range_slider = jQuery(Price_range.p_slider_id);
			
			// Change our price range slider to live price components.
			///price_range_slider.attr('data-sh-price-max','50000');
			///price_range_slider.attr('data-sh-price-max-current','50000');
			///price_range_slider.find('.feedback h4').text('Based on live price totals');
							
			///Price_range.set_slider(); //Price_range.init();
	    });
	}
	,
	update_settings : function(pm_config = {})
	{
		// Find the slider.
		var price_range_slider = jQuery(Price_range.p_slider_id);
		
		// Check if we are updating the current minimum price.
		if( typeof pm_config.price_min_current !== 'undefined' )
		{
			// Update data attribute.
			var price_min_current = parseInt(pm_config.price_min_current);
			price_range_slider.attr('data-sh-price-min-current',price_min_current);
			
			// Update tracking element.
			jQuery('input[name="price_min"]').val(price_min_current);
		}
		
		// Check if we are updating the minimum price.
		if( typeof pm_config.price_min !== 'undefined' )
		{
			// Update data attribute.
			var price_min = parseInt(pm_config.price_min);
			price_range_slider.attr('data-sh-price-min',price_min);
		}
		
		// Check if we are updating the current maximum price.
		if( typeof pm_config.price_max_current !== 'undefined' )
		{
			// Update data attribute.
			var price_max_current = parseInt(pm_config.price_max_current);
			price_range_slider.attr('data-sh-price-max-current',price_max_current);
			
			// Update tracking element.
			jQuery('input[name="price_max"]').val(price_max_current);
		}
		
		// Check if we are updating the maximum price.
		if( typeof pm_config.price_max !== 'undefined' )
		{
			// Update data attribute.
			var price_max = parseInt(pm_config.price_max);
			price_range_slider.attr('data-sh-price-max',price_max);
		}
		
		// Check if we are updating the price step.
		if( typeof pm_config.price_step !== 'undefined' )
		{
			// Update data attribute.
			var price_step = parseInt(pm_config.price_step);
			price_range_slider.attr('data-sh-price-step',price_step);
		}
		
		// Set the slider for the new settings.
		Price_range.set_slider();
	}
}

jQuery(document).ready(function(jQuery){
	
	// Price range utilises a price slider to consolidate minimum and maximum price values on a search.
	Price_range.init();

});